import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import "./component.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ListHistoryProduk = () => {
  const { user } = useSelector((state) => state.auth);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      getProductsByRole();
    }
  }, [user]);

  const getProductsByRole = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("Token not found");
      return;
    }

    try {
      const response = await axios.get(
        `https://c-greenproject.org:8000/historyorder`,
        {
          params: {
            role: user.role,
            name: user.name,
            email: user.email,
            userId: user.uuid,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setProducts(response.data);
    } catch (error) {
      console.error("Error fetching products by role:", error);
    }
  };

  const formatRupiah = (angka) => {
    if (!angka) return "Rp 0";
    return `Rp ${angka.toLocaleString("id-ID")}`;
  };

  return (
    <div>
      <h2 className="title">
        <strong>History Order Panen</strong>
      </h2>
      <div className="detail-table-container">
        <table className="table is-striped is-fullwidth detail-table">
          <thead>
            <tr>
              <th>No</th>
              <th>Nama Petani</th>
              <th>Varietas</th>
              <th>Nama Logistik</th>
              <th>Nama Pabrik</th>
              <th>Tanggal Panen</th>
              <th>Berat(kg)</th>
              <th>Harga Aktual</th>
              <th>Kode Blockchain</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product, index) => (
              <React.Fragment key={product.uuid}>
                <tr>
                  <td>{index + 1}</td>
                  <td>{product.user?.name || "No Name"}</td>
                  <td>{product.varietasSingkong}</td>
                  <td>{product.namaLogistik || "No Logistics"}</td>
                  <td>{product.namaPabrik || "No Factory"}</td>
                  <td>{product.tanggalPemanenan}</td>
                  <td>
                    {product.data_transaksipbks?.[0]?.beratTotalDiterima ||
                      "N/A"}{" "}
                    kg
                  </td>
                  <td>
                    {formatRupiah(product.data_transaksiprs?.[0]?.hargaaktual)}
                  </td>
                  <td>{product.uuid}</td>
                </tr>
                <tr className="detail-row">
                  <td colSpan="9">
                    <Button
                      variant="link"
                      className="btn-sm detail-button"
                      onClick={() => navigate(`/historyorder/${product.uuid}`)}
                    >
                      Lihat Detail Order
                    </Button>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListHistoryProduk;
